export const GET_LINK_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    link(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      linkText
      linkDescription
      url
      reference{
        ...on Page {
          content {
            __typename
          }
          slug
        }
        ...on FileBlock
        {
          imageVaultFile
          __typename
        }
      }
      globalLinkItem
      newTab
      variant
      buttonVariant
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
